import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { SharedService } from '@AppRoot/shared/services/shared.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CartItemsData } from '@AppShared/models/common.interface';
import { APIResponse } from '@AppRoot/shared/models/api-response.interface';
import { Router } from '@angular/router';
import { ShoppingService } from '../../shopping.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
})
export class CartComponent {
  cardsData: Array<CartItemsData> = [];
  quantity: number = 0;
  showLoader: boolean = true;
  shippingCost: number = 250;
  total: number = 1400;
  totalDiscount = 0;
  currentProductUpdateIndex: number = 0;

  @Output() checkout = new EventEmitter<boolean>();
  @Output() close = new EventEmitter<boolean>();

  @Input() minimal: boolean = false;

  constructor(
    private router: Router,
    private _globalUtilityService: GlobalUtilityService,
    private _sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.getCartItems();
  }

  getCartItems() {
    this._sharedService.getCartItems().subscribe({
      next: (data: APIResponse) => {
        this.cardsData = data?.data?.cart_items || [];
        this.quantity = data.data?.cart_items?.length || 0;
        if (this.currentProductUpdateIndex !== null && this.cardsData.length) {
          this.cardsData[this.currentProductUpdateIndex].loading = false;
        }
        this.showLoader = false;
        this.proceedToCheckout();
      },
      error: (error: any) => {
        this._globalUtilityService.hideLoader();
        this._globalUtilityService.showToast('Error', error.message);
        if (this.currentProductUpdateIndex !== null) {
          this.cardsData[this.currentProductUpdateIndex].loading = false;
        }
        this.showLoader = false;
        this.proceedToCheckout(false);
      },
    });
  }

  navigateToBuy(){
    this.router.navigate(['/products']);
    this.close.emit(true);
  }

  increaseQuantity(
    i: number,
    product_id: number,
    product_size_id: number,
    quantity: number,
    available_quantity: number
  ) {
    if (available_quantity <= quantity + 1) {
      this._globalUtilityService.showToast(
        'Error',
        'No more quantity available for this product. It will be available soon!'
      );
      return;
    }
    this.cardsData[i].loading = true;
    this.currentProductUpdateIndex = i;
    this._sharedService
      .updateCart(product_size_id, product_id, 1, 1)
      .subscribe({
        next: (res: Partial<APIResponse>) => {
          if (res) {
            this._globalUtilityService.showToast('Success', 'Item updated');
            this._sharedService.cartUpdated.next(true);
            this.cardsData[i].loading = false;
            this.cardsData[i].quantity = quantity + 1;
            this.proceedToCheckout(true);
          }
        },
        error: (error: any) => {
          this._globalUtilityService.hideLoader();
          this._globalUtilityService.showToast('Error', error.message);
          this.cardsData[i].loading = false;
          this.proceedToCheckout(false);
        },
      });
  }

  decreaseQuantity(
    i: number,
    product_size_id: number,
    product_id: number,
    quantity: number
  ) {
    this.cardsData[i].loading = true;
    this.currentProductUpdateIndex = i;

    this._sharedService
      .updateCart(product_size_id, product_id, 1, -1)
      .subscribe({
        next: (res: any) => {
          if (res) {
            if (quantity == 0) {
              this.cardsData.splice(i, 1);
            }
            this._globalUtilityService.showToast('Success', 'Item updated');
            if (quantity != 0 && this.cardsData[i]) {
              this.cardsData[i].quantity = quantity;
              this.cardsData[i].loading = false;
            }
            this._sharedService.cartUpdated.next(true);
            this.proceedToCheckout();
          }
        },
        error: (error: any) => {
          this._globalUtilityService.hideLoader();
          this._globalUtilityService.showToast('Error', error.message);
          this.cardsData[i].loading = false;
          this.proceedToCheckout(false);
        },
      });
  }

  removeItem(i: number, product_size_id: number) {
    this._sharedService.removeProductFromCart(product_size_id).subscribe({
      next: (res: any) => {
        if (res) {
          this._globalUtilityService.showToast('', 'Product removed from cart');
          this._sharedService.cartUpdated.next(true);
          this.cardsData.splice(i, 1);
          if (this.cardsData[i]) {
            this.cardsData[i].loading = false;
          }
          this.proceedToCheckout();
        }
      },
      error: (error: any) => {
        this.proceedToCheckout(false);
        this.cardsData[i].loading = false;
        this._globalUtilityService.hideLoader();
        this._globalUtilityService.showToast('', error.message);
      },
    });
  }

  proceedToCheckout(checkout: boolean = true) {
    if (this.cardsData.length > 0 && checkout) {
      this.checkout.emit(true);
      return;
    }
    this.checkout.emit(false);
  }
}
